<template>
	<div>
    <loader v-if="ticket_detail.loader" />
	  <div v-else class="chat-container w-100 position-relative bg-green pb-5 hide-scroll overflow-scroll" style="height: 100%">
	    <div class="text-right pt-3 px-4">
        <img src="../../assets/img/icon/cancel.png" class="text-right" width="22">	
	    </div>
	    <div class="container mt-8 text-center">
	      <div class="border rounded-50 size-icon mx-auto">
	        <div class="bg-white rounded-50 size-icon-in">
	          <img src="../../assets/img/icon/correct.png" width="40" style="margin: 16px 15px">
	        </div>
	      </div>
	      <p class="mt-4 mb-0 heading-5-2 text-white">{{formatCurrency(ticket_detail.data.total_payment)}}</p>
	      <p class="mt-2 mb-4 body-2-2" style="color: #FFFFFFA6">{{formatDate(ticket_detail.data.transaction_date)}}</p>
	      <p class="body-2-4 text-white pt-4 mb-0">Booking ID {{ticket_detail.data.ticket_code}}</p>
	      <p class="sub-heading-1-2 text-white mt-2">{{$t('merchant.thanks-for-buying-tickets')}}</p>

	      <div class="mx-2 text-left bg-white pt-4 pb-0" style="border-radius: 8px;box-shadow: 0px 9px 11px 0px #00000052">
	        <div class="row slim-grid-row pb-4">
	          <div class="col-2 text-right">
	            <img src="../../assets/img/icon/tickets.png" class="pt-2" width="20">
	          </div>
	          <div class="col-9">
	            <p class="mb-1 body-2-1">{{ticket_detail.data.merchant.name}} Tickets</p>
	            <p class="mb-0 body-3-3-1 text-light-bold">{{$t('merchant.visit-date')}} : {{formatDate(ticket_detail.data.visit_date)}}</p>
	          </div>
	        </div>
	      </div>
	      <router-link :to="'/'+getMerchant().code+'/ticket/order-history'">
	      <button class="btn mx-auto border rounded-6 py-2 text-white sub-heading-1-2" style="width: 245px;margin-top: 35px;">{{$t('general.see-order-list')}}</button>
	      </router-link>
	    </div>
	    <div class="pt-12"></div>
	  </div>
	</div>
</template>
<script>
	import {get} from '@/services/index.js';
	import {formatCurrency,formatDate} from '@/utils/index.js'
  import {mapActions,mapGetters} from "vuex";
  export default {
    data() {
      return {
        ticket_detail:{
        	loader: false,
        	data: {}
        }
      }
    },
    mounted(){
    	this.loadTicketDetail();
      this.ticketResetItemCart();
      this.ticketSetOwnerCart('me');
    },
    methods:{
      ...mapGetters(['getMerchant']),
      ...mapActions([
        'ticketSetOwnerCart',
        'ticketResetItemCart',]),
    	formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
    	loadTicketDetail(){
    		this.ticket_detail.loader = true
    		get("CORE","tx-ticket-detail/"+this.$route.params.tx_order_id).then(response=>{
    			let res = response.data;
    			if (res.success) {
    				this.ticket_detail.data = res.data
    			}
    			this.ticket_detail.loader = false
    		})
    	}
    }
  }
</script>
<style scoped>
  .size-icon {
    width: 85px;
    height: 85px;
    padding: 7px;
  }

  .size-icon-in {
    width: 70px;
    height: 70px
  }

  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .hide-scroll {
    -ms-overflow-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ticket/DokuRedirect.vue